import { animate, style, transition, trigger } from "@angular/animations";

export const slideInRight = trigger('slideInRight', [
  transition(':enter', [
    style({ transform: 'translateX(100%)', opacity: 0 }),
    animate(
      '400ms ease',
      style({ transform: 'translateX(0)', opacity: 1 })
    ),
  ]),
  transition(':leave', [
    animate(
      '400ms ease',
      style({ transform: 'translateX(100%)', opacity: 0 })
    ),
  ]),
]);
